import React from "react";
// Import pdfs
import baxrx_flyer from "../../../assets/pdf/resources/baxrx_flyer.pdf";
import baxrx_employer_program from "../../../assets/pdf/resources/baxrx_employer_program.pdf";
import baxrx_formulary from "../../../assets/pdf/resources/baxrx_formulary.pdf";
import baxrx_broker_toolkit from "../../../assets/pdf/resources/baxrx_broker_toolkit.pdf";
import baxrx_comparison_chart from "../../../assets/pdf/resources/baxrx_comparison_chart.pdf";

import { Button } from "reactstrap";
import uploadCloud from "../../../assets/images/upload-cloud-02.svg";

const itemsDownloadable = [
  {
    name: "BaxRx Flyer",
    file: baxrx_flyer,
    customFileName: "BaxRx_Flyer.pdf",
  },
  {
    name: "BaxRx Employer Program",
    file: baxrx_employer_program,
    customFileName: "BaxRx_Employer_Program.pdf",
  },
  {
    name: "Formulary",
    file: baxrx_formulary,
    customFileName: "BaxRx_Formulary.pdf",
  },
  {
    name: "BaxRx Broker Toolkit",
    file: baxrx_broker_toolkit,
    customFileName: "BaxRx_Broker_Toolkit.pdf",
  },
  {
    name: "Competition Comparison Chart",
    file: baxrx_comparison_chart,
    customFileName: "BaxRx_Comparison_Chart.pdf",
  },
];

const DownloadableResource = () => {
  const handleDownload = (file, customFileName) => {
    const link = document.createElement("a");
    link.href = file;
    link.setAttribute("download", customFileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <h2>Marketing Material</h2>
      <div className="row mt-5">
        {itemsDownloadable.map((item, index) => {
          return (
            <div key={index} className="col-6 mb-4">
              <div className="border border-2  border-dashed rounded p-3 text-center">
                <div className="mb-3">
                  <img
                    src={uploadCloud}
                    alt={`${item.name}`}
                    className="mb-2 bg-light p-2 rounded-circle"
                  />
                </div>

                <h4>{item.name}</h4>
                <div className="my-3">
                  <span
                    onClick={() =>
                      handleDownload(item.file, item.customFileName)
                    }
                    className="d-block mb-2 text-primary cursor-pointer text-decoration-underline"
                  >
                    Download PDF Now
                  </span>
                  <Button
                    onClick={() =>
                      handleDownload(item.file, item.customFileName)
                    }
                    style={{ width: "60%" }}
                    className="btn btn-primary mt-3"
                  >
                    Download
                  </Button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default DownloadableResource;
